var _path, _path2, _path3, _path4, _path5, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicationLevelAttack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0935 16.7031H16.9062C15.9914 16.7031 15.2578 17.4449 15.2578 18.3515V28.242C15.2578 29.1486 15.9914 29.8904 16.9062 29.8904H30.0935C31.0001 29.8904 31.7419 29.1486 31.7419 28.242V18.3515C31.7419 17.4449 31.0083 16.7031 30.0935 16.7031ZM30.0935 28.242H16.9062V19.9999H30.0935V28.242Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.258 25.249L20.7908 23.7819L22.258 22.3147C22.4047 22.168 22.4047 21.9347 22.258 21.788C22.1113 21.6413 21.878 21.6413 21.7313 21.788L20.0046 23.5148C19.8579 23.6615 19.8579 23.8985 20.0046 24.0452L21.7313 25.7757C21.878 25.9224 22.1113 25.9224 22.258 25.7757C22.4047 25.629 22.4047 25.3958 22.258 25.249ZM24.7409 25.249L26.2081 23.7819L24.7409 22.3147C24.5942 22.168 24.5942 21.9347 24.7409 21.788C24.8876 21.6413 25.1209 21.6413 25.2676 21.788L26.9943 23.5148C27.141 23.6615 27.141 23.8985 26.9943 24.0452L25.2676 25.7757C25.1209 25.9224 24.8876 25.9224 24.7409 25.7757C24.5942 25.629 24.5942 25.3958 24.7409 25.249Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9079 28.2966C35.9079 30.5978 34.0424 32.4633 31.7412 32.4633C29.44 32.4633 27.5745 30.5978 27.5745 28.2966C27.5745 25.9954 29.44 24.13 31.7412 24.13C34.0424 24.13 35.9079 25.9954 35.9079 28.2966Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7412 23.2966C28.9812 23.2966 26.7412 25.5366 26.7412 28.2966C26.7412 31.0566 28.9812 33.2966 31.7412 33.2966C34.5012 33.2966 36.7412 31.0566 36.7412 28.2966C36.7412 25.5366 34.5012 23.2966 31.7412 23.2966ZM31.7412 32.2966C29.5362 32.2966 27.7412 30.5016 27.7412 28.2966C27.7412 26.0916 29.5362 24.2966 31.7412 24.2966C33.9462 24.2966 35.7412 26.0916 35.7412 28.2966C35.7412 30.5016 33.9462 32.2966 31.7412 32.2966Z",
    fill: "#141414"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7168 25.7891V28.6423",
    stroke: "#141414",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.7171,
    cy: 30.6395,
    r: 0.570647,
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationLevelAttack);
export default __webpack_public_path__ + "static/media/application_level_attack.7ca47edb65c8ab7380c488ceb5c2880d.svg";
export { ForwardRef as ReactComponent };